import { PhaseTypeEnum } from '../../phase/enums/phase-type.enum';

// required means that the phase must me approved in order to be advanced

//Drywall
export const JOB_PHASE_REQUIRED_PHASE_TYPES_DRYWALL = [
  PhaseTypeEnum.Materials,
  PhaseTypeEnum.Hanging,
  PhaseTypeEnum.Finishing,
  PhaseTypeEnum.Spraying,
  PhaseTypeEnum.Bump1,
  PhaseTypeEnum.Bump2,
  PhaseTypeEnum.Bump3,
  PhaseTypeEnum.Bump4,
  PhaseTypeEnum.Bump5,
];

export const JOB_PHASE_REQUIRED_PHASE_TYPES_DRYWALL_AND_PAINT = [
  PhaseTypeEnum.Materials,
  PhaseTypeEnum.Garage,
  PhaseTypeEnum.Hang,
  PhaseTypeEnum.Finish,
  PhaseTypeEnum.Prime,
  PhaseTypeEnum.DrywallTouchUp1,
  PhaseTypeEnum.Trim1,
  PhaseTypeEnum.InteriorPaint,
  PhaseTypeEnum.DrywallTouchUp2,
  PhaseTypeEnum.Trim2,
  PhaseTypeEnum.FinalPaint,
  PhaseTypeEnum.DrywallTouchUp3,
  PhaseTypeEnum.CMBluetape,
  PhaseTypeEnum.FinalBluetape,
];

export const JOB_PHASE_BUMP_PHASE_TYPES_DRYWALL = [
  PhaseTypeEnum.Bump1,
  PhaseTypeEnum.Bump2,
  PhaseTypeEnum.Bump3,
  PhaseTypeEnum.Bump4,
  PhaseTypeEnum.Bump5,
];

export const JOB_PHASE_BUMP_PHASE_TYPES_DRYWALL_AND_PAINT = [
  PhaseTypeEnum.DrywallTouchUp1,
  PhaseTypeEnum.DrywallTouchUp2,
  PhaseTypeEnum.DrywallTouchUp3,
  PhaseTypeEnum.CMBluetape,
  PhaseTypeEnum.FinalBluetape,
];
